import React from 'react'

const  DueDateIcon  = (props) =>  {
       const { color } = props

       return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none">
       <path fillRule="evenodd" clipRule="evenodd" d="M10 2H6V0.666668H10V2Z" fill={color}/>
       <path fillRule="evenodd" clipRule="evenodd" d="M8.66659 4H7.33325V0.666668H8.66659V4Z" fill={color}/>
       <path fillRule="evenodd" clipRule="evenodd" d="M8.00008 14C10.7615 14 13.0001 11.7614 13.0001 9C13.0001 6.23858 10.7615 4 8.00008 4C5.23866 4 3.00008 6.23858 3.00008 9C3.00008 11.7614 5.23866 14 8.00008 14ZM8.00008 15.3333C11.4979 15.3333 14.3334 12.4978 14.3334 9C14.3334 5.5022 11.4979 2.66667 8.00008 2.66667C4.50228 2.66667 1.66675 5.5022 1.66675 9C1.66675 12.4978 4.50228 15.3333 8.00008 15.3333Z" fill={color}/>
       <path fillRule="evenodd" clipRule="evenodd" d="M11.5286 4.86193L13.5286 2.86193L14.4714 3.80474L12.4714 5.80474L11.5286 4.86193Z" fill={color}/>
       <path fillRule="evenodd" clipRule="evenodd" d="M7.33325 5.33333H8.66659V8.92131L10.9647 10.0704L10.3684 11.2629L7.33325 9.74535V5.33333Z" fill={color}/>
       </svg>
}

export default DueDateIcon